import { render } from "./NewUserModal.vue?vue&type=template&id=6af0dc68"
import script from "./NewUserModal.vue?vue&type=script&lang=js"
export * from "./NewUserModal.vue?vue&type=script&lang=js"

import "./NewUserModal.vue?vue&type=style&index=0&id=6af0dc68&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__